import { Box, Typography } from "@mui/material";

interface Props {
  title: string;
  description?: string;
}

export function VerticalTabContent({ title, description }: Props) {
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      sx={{
        minWidth: 0,
        overflowWrap: "break-word",
        wordBreak: "break-word",
      }}
    >
      <Typography
        variant="body2"
        fontWeight={500}
        color={"#4B465C"}
        sx={{ wordBreak: "break-word" }}
      >
        {title}
      </Typography>

      <Typography
        variant="caption"
        color={"#A1A1A1"}
        sx={{ wordBreak: "break-word" }}
      >
        {description}
      </Typography>
    </Box>
  );
}
